import React, { FC } from 'react';
import { createBrowserHistory } from 'history';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import TermsConsentPage from './pages/authentication/TermsConsentPage';
import NotFound404Page from './pages/not-found-404-page/NotFound404Page';

const history = createBrowserHistory();

const App: FC = () => (
    <Router history={history}>
        <Switch>
            <Route exact path={['/consent']} render={() => <TermsConsentPage />} />
            <Route
                exact
                path={['/']}
                render={() => (
                        <Redirect
                            to={{ pathname: '/consent' }}
                        />
                    )}
                />
            <Route render={() => <NotFound404Page />} />
        </Switch>
    </Router>
);


export default App;
